import React, { useState, useEffect, useMemo } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import axios from "axios";
import _ from "lodash";
import slugify from "../common/slugify";
import Description from "../common/Description";

const IntroductionSection = ({
  config,
  language,
  culture,
  section,
  settingsData,
  bookingData,
}) => {
  const [content, setContent] = useState();
  const [showLongText, setShowLongText] = useState(false);
  const [text, setText] = useState();
  const filter = bookingData.filter((el) => el.name === section.name);

  const fileName = useMemo(() => {
    if (filter) {
      return `${filter?.[0]?.description}.${culture}.md`;
    } else return "";
  }, [filter]);

  useEffect(() => {
    if (filter.length > 0 && settingsData) {
      axios.all([
        axios
          .get(
            `${config.baseUrl}/ee-static/shop/${config.shopName}//Texts/${fileName}`,
            {
              headers: {
                "Cache-Control": "no-cache, no-store, must-revalidate",
                Pragma: "no-cache",
                Expires: "0",
              },
            }
          )
          .then((data) => setText(data.data))
          .catch((err) => {
            console.error(err);
            setText("");
          }),
      ]);
      setContent(filter);
    }
  }, [bookingData, settingsData, section]);

  return (
    <div
      className="introductionWrapper"
      key="introduction"
      style={{
        marginTop: bookingData.length === 1 ? "-2rem" : "",
        transition: bookingData.length === 1 ? "none" : "",
      }}
    >
      {sessionStorage.getItem("articleBookingBtn") !== "notactive" ? (
        <>
          <div className="introductionHeader"></div>
          {content && content[0] !== undefined ? (
            <div
              className="introductionTextWrapper"
              key="articleBookingIntroductionWrapper"
            >
              <img
                src={`${config.baseUrl}${config.imageFolderUrl}${content[0].introductionImage}`}
                key="articleBookingImg"
                className="introductionImage"
                alt={`${language.ImageAltText} ${content[0].name}`}
              />
              <div className="introductionText">
                {text &&
                window.screen.availWidth <= 768 &&
                text.length > 300 ? (
                  <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                    {showLongText
                      ? text
                      : _.truncate(text, { length: 300 }) + "... "}
                  </ReactMarkdown>
                ) : (
                  <Description text={text} fileName={fileName} />
                )}
              </div>
              {text && text?.length > 300 ? (
                <button
                  className="readMoreButton"
                  onClick={() => setShowLongText(!showLongText)}
                  aria-label={
                    !showLongText
                      ? language.ArticleBooking.ReadMoreButton
                      : language.ArticleBooking.HideText
                  }
                >
                  {!showLongText
                    ? language.ArticleBooking.ReadMoreButton
                    : language.ArticleBooking.HideText}
                </button>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default IntroductionSection;
